<template>
  <div class="report-section report-section-header">
    <div v-if="reportData.options?.name || reportData.name" class="section-title">{{ reportData.options?.name || reportData.name }}</div>
    <div v-if="reportData.options?.description || reportData.description" class="section-description">{{ reportData.options?.description || reportData.description }}</div>
    <overview-card ref="overviewCard" :scope="$store.getters.scope" is-template :is-template-edit="isTemplateEdit" :template-params="reportData.queryParams || reportData.options?.queryParams" :scopeParams="scopeParams" />
  </div>
</template>

<script>
import OverviewCard from '@Monitor/components/MonitorCard/OverviewCard'

export default {
  name: 'ReportMetricTable',
  components: {
    OverviewCard,
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
    isTemplateEdit: {
      type: Boolean,
      default: false,
    },
    scopeParams: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted () {
    this.$nextTick(() => {
      const card = this.$refs.overviewCard
      if (!card) return
      this._overviewDataWatch = this.$watch(
        () => ({
          loading: card.tableLoading,
          rows: card.table?.rows,
          showTable: card.showTable,
        }),
        (state) => {
          if (this.isTemplateEdit || state.loading) return
          this.$emit('resourceListHidden', this.isOverviewDataEmpty(state))
        },
        { deep: true },
      )
    })
  },
  beforeDestroy () {
    if (this._overviewDataWatch) {
      this._overviewDataWatch()
    }
  },
  methods: {
    getTemplateParams () {
      return this.$refs.overviewCard.getTemplateParams()
    },
    isOverviewDataEmpty ({ showTable, rows }) {
      if (!showTable) return true
      return !Array.isArray(rows) || rows.length === 0
    },
  },
}
</script>

<style lang="less" scoped>
.section-title {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 15px;
}
.section-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}
</style>
